module.exports = __webpack_public_path__ + "img/Materiales.363a90ac.svg";